import { Component, Inject, OnChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { CommonModule } from '@angular/common';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { FormsModule, NgModel } from '@angular/forms';

@Component({
  selector: 'app-dialog-graphscale-vpf-settings',
  templateUrl: './dialog-graphscale-vpf-settings.component.html',
  styleUrls: ['./dialog-graphscale-vpf-settings.component.scss'],
  standalone:true,
  imports:[CommonModule,MatButtonModule,FormsModule]
})
export class DialogGraphscaleVpfSettingsComponent implements OnChanges {
  loading: boolean = true;
  invalidValues={
    th1_invalid:false,
    th2_invalid:false,
    th3_invalid:false,
    orieX_default:false,
    orieY_default:false,
    orieZ_default:false,
  }
  public powerFactorData:any
  public otherData:any
  constructor(
    public dialogRef: MatDialogRef<DialogGraphscaleVpfSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public service: BackendApiService
  ) { 
    if (this.data.loading !== undefined) {
      this.loading = this.data.loading;
    } else {
      this.loading = false;
    }
  }

  ngOnChanges() {
    if (this.data.loading !== undefined) {
      this.loading = this.data.loading;
    } else {
      this.loading = false;
    }
  }

  updateData(newData: any): void {
    this.loading = false;
    this.data = newData;
    // In your component (e.g., ngOnInit or after data is received)
    this.powerFactorData = this.data.filter(item => item.metric_type === 'PowerFactor');
    this.otherData = this.data.filter(item => item.metric_type !== 'PowerFactor');

    console.log(this.data)
  }

  onSave(): void {
    let isValid=true
  
    if(this.data.length>2){
      for(let i=0; i<this.data.length-1; i++){
        let {base_value,max_value,threshold_1,threshold_2,threshold_3,orieX_default,orieY_default,orieZ_default}=this.data[i];
        console.log(base_value,max_value,threshold_1,threshold_2,threshold_3,orieX_default,orieY_default,orieZ_default)
        if(base_value>=max_value || base_value >=threshold_1){
          isValid=false;
          this.service.showError("Invalid Range")
          return
        }else if(max_value<=threshold_1 || max_value<=threshold_2 || max_value<=threshold_3 || max_value<= orieX_default || max_value<= orieY_default|| max_value<= orieZ_default){
          isValid=false;
          this.service.showError("Invalid Range")
          return
        }else if(threshold_1>=threshold_2 || threshold_1>=threshold_3 || threshold_1>=orieX_default || threshold_1>=orieY_default || threshold_1 >= orieZ_default){
          isValid=false;
          this.service.showError("Invalid under red")
          return
        }else if(threshold_2>=threshold_3 || threshold_2>=orieX_default || threshold_2>=orieY_default || threshold_2 >= orieZ_default){
          isValid=false;
          this.service.showError("Invalid under yellow")
          return
        }else if(threshold_3>=orieX_default || threshold_3>=orieY_default || threshold_3 >= orieZ_default){
          isValid=false;
          this.service.showError("Invalid under green")
          return
        }else if(orieX_default>=orieY_default || orieX_default>=orieZ_default){
          isValid=false;
          this.service.showError("Invalid Over green value")
          return
        }else if(  orieY_default>=orieZ_default){
          isValid=false;
          this.service.showError("Invalid Over yellow value")
          return
        }
      }
    }
   
    if(isValid)this.dialogRef.close(this.data); // Pass modified data back to parent component
    else this.service.showError("Invalid values")
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

